import { useFooterModel } from '@/components/shared/footer/footer.model'
import { FooterView } from '@/components/shared/footer/footer.view'

export function FooterViewModel() {
  const model = useFooterModel()
  return <FooterView {...model} />
}
